export const FRUSTRATION_LABELS = {
  p: 'Фрустрация отсутствует',
  e: 'Экстрапунитивный, потребностно-неустойчивый',
  E: 'Экстрапунитивный, эго-защитный',
  "E'": 'Экстрапунитивный, препятственно-доминантный',
  f: 'Другой тип фрустрации',
};

// ISO-неделя начинается в понедельник и может пересекать границу года.
export const frustrationPeriodBounds = (key, period, startDate, endDate) => {
  let start;
  let end;
  if (period === 'week') {
    const [year, week] = key.split('-W').map(Number);
    start = new Date(Date.UTC(year, 0, 4));
    start.setUTCDate(start.getUTCDate() - ((start.getUTCDay() + 6) % 7) + (week - 1) * 7);
    end = new Date(start);
    end.setUTCDate(end.getUTCDate() + 6);
  } else if (period === 'month') {
    const [year, month] = key.split('-').map(Number);
    start = new Date(Date.UTC(year, month - 1, 1));
    end = new Date(Date.UTC(year, month, 0));
  } else {
    start = new Date(`${key}T00:00:00Z`);
    end = new Date(start);
  }
  const first = start.toISOString().slice(0, 10);
  const last = end.toISOString().slice(0, 10);
  return {
    start_date: startDate && startDate > first ? startDate : first,
    end_date: endDate && endDate < last ? endDate : last,
  };
};

export const loadFrustrationPosts = async (fetchPage, groupTitle) => {
  const posts = new Map();
  let page = 1;
  let loaded = 0;
  while (true) {
    const payload = await fetchPage(page);
    const records = payload.data || [];
    records.forEach((record) => {
      const key = `${record.group_id}:${record.post_id}`;
      if (!posts.has(key)) {
        const ownerId = -Math.abs(Number(record.group_id));
        posts.set(key, {
          'ID поста': record.post_id,
          'Группа': groupTitle(record.group_id),
          'Дата': record.post_date || record.date,
          'Текст': record.post_text || '',
          'Ссылка на пост': `https://vk.com/wall${ownerId}_${record.post_id}`,
          frustrationSentences: [],
        });
      }
      posts.get(key).frustrationSentences.push(record);
    });
    loaded += records.length;
    if (loaded >= payload.total) break;
    if (!records.length) throw new Error('Неполная детализация фрустрации');
    page += 1;
  }
  return Array.from(posts.values());
};
